module.exports = __webpack_public_path__ + "static/media/guarding_channel.d2d2bfc4.webp";